/**
* @Author: Roxy Chen
* @Date:   2016-08-17T18:00:27+08:00
* @Last modified by:   Roxy Chen
* @Last modified time: 2016-08-20T03:37:56+08:00
* @License: Copyright (c) by Giftpack Inc. All Rights Reserved.
*/

import "./sass/style.scss";
import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import Routes from "./script/tool/routes";
import Index from "./script/component/index";
//import Login from './script/component/login';

const container = document.getElementById("main");
const root = createRoot(container);
root.render(Routes);
